module.exports = __webpack_public_path__ + "img/excel.ef6df88a.svg";